import CustomSwitch from "../../../../components/CustomSwitch";

const Distribution = ({ configState, handleConfigSwitchChange }) => {


  const label = { inputProps: { "aria-label": "Switch demo" }, color: "success" };
  return (
    <>
      <div className="global-settings-section-div">
        <div style={{ margin: "0 2em 0 0" }}>
          <h4 style={{ fontWeight: "600", margin: "0 0 0.5em 0" }}>
            Pause Hive for All Users
          </h4>
          <p style={{ margin: "0 0 1em 0" }}>
            When enabled, new jobs aren’t displayed to Bees and only Admins will be able to claim jobs.

            <span style={{ fontWeight: '600' }} > Click and confirm to toggle.</span>
          </p>
        </div>
        <div className="global-settings-section-input">
          {/* <label htmlFor="CustomSwitch">{configState?.enableJobClaiming?.value?"Enable":"Disable"}</label> */}
          <CustomSwitch
            {...label}
            checked={!configState?.enableJobClaiming?.value ?? true}
            onChange={() =>
              handleConfigSwitchChange({
                ...configState?.enableJobClaiming,
                value: !configState?.enableJobClaiming?.value,
              })
            }
          />
        </div>
      </div>

      <div className="global-settings-section-div">
        <div style={{ margin: "0 2em 0 0" }}>
          <h4 style={{ fontWeight: "600", margin: "0 0 0.5em 0" }}>
            Pause Hive For Swarms
          </h4>
          <p style={{ margin: "0 0 1em 0" }}>
            When enabled, only NewBee users and Admins can claim jobs.

            <span style={{ fontWeight: '600' }} > Click and confirm to toggle.</span>
          </p>
        </div>
        <div className="global-settings-section-input">
          {/* <label htmlFor="CustomSwitch">{configState?.enableJobClaiming?.value?"Enable":"Disable"}</label> */}
          <CustomSwitch
            {...label}
            checked={configState?.DisableDistributionForSwarm?.value}
            onChange={() => handleConfigSwitchChange({
              ...configState?.DisableDistributionForSwarm,
              value: !configState?.DisableDistributionForSwarm?.value,
            })}
          />
        </div>
      </div>
    </>
  );
};

export default Distribution;
